export interface Document {
	id: number;
	path: string;
	name: string;
	fileNamePdf: string;
	fileNameXml: string;
	type: DocumentType;
	subtype: string;
	date: string;
	millCode: string;
	payerBusinessId: string;
	soldtoBusinessId: string;
	shiptoBusinessId: string;
	supplierMemberId: number;
	customerOrderReference: string;
	supplierOrderReference: string;
	transportMode: string;
	transmitterSystem: string;
	supplierVatNumber: string;
	payerVatNumber: string;
	customerClaimReference: string;
	supplierClaimReference: string;
	salesOrganization: string;
	customerAnnouncementSegment: string;
	proforma: string;
	ceMarking: number;
	counterSigned: number;
	documentKey: string;
	documentBase: string;
	orderAcknowledgementDate: string;
	dispatchAdviceDate: string;
	paymentDueDate: string;
	invoiceNumber: string;
	payerName: string;
	soldtoName: string;
	shiptoName: string;
	invoicedQuantity?: string;
	invoiceAmount?: number;
	invoiceAmountWithoutVat?: number;
	invoiceCurrency?: string;
	invoiceTaxAmount?: number;
	documentLines: DocumentLine[];
	receiptDocumentDate: string;
	documentCreationBy: string;
	documentModificationDate: string;
	documentModificationBy: string;
	typeDescription: string;
	subtypeDescription: string;
	millDescription: string;
	supplierMemberDescription: string;
	transportModeDescription: string;
	docNavigationLink?: string;
	isSbOrder?: boolean;
	rrpType: string;
	rrpDocumentLink: string;
	amount: number;
}

export interface DocumentLine {
	id: number;
	millCode: string;
	soldtoBusinessId: string;
	shiptoBusinessId: string;
	enduserBusinessId: string;
	payerBusinessId: string;
	supplierGroupId: string;
	customerOrderReference: string;
	customerOrderItemReference: string;
	supplierOrderReference: string;
	supplierOrderReferenceItem: string;
	millOrderReference: string;
	millOrderReferenceItem: string;
	customerArticleReference: string;
	supplierArticleReference: string;
	dispatchAdviceNumber: string;
	batchNumber: string;
	vendorBatchId: string;
	heatNumber: string;
	transportReference: string;
	packageSerialNumber: string;
	productDescription: string;
	length: number;
	invoicedQuantity: number;
	invoicedQuatityUnit: string;
	invoiceAmount: number;
	plantInvoiceNumber: string;
	invoiceVatPercentage: number;
	invoiceAmountWithoutVat: number;
	invoiceCurrency: string;
	invoiceTaxAmount: number;
	orderedQuantity: number;
	steelGrade: string;
	thickness: number;
	width: number;
	finalUse: string;
	oaLineStatus: string;
	rejectionReason: string;
	dispatchAdviceDate: string;
	displayOrderLines: number;
	soldtoName: string;
	shiptoName: string;
	enduserName: string;
	payerName: string;
	receiptDocumentLineDate: string;
	documentLineCreationBy: string;
	documentLineModificationDate: string;
	documentLineModificationBy: string;
	millDescription: string;
	supplierMemberDescription: string;
	invoiceCurrencyDescription: string;
	payerVatNumber: string;
	oaLineStatusDescription: string;
	isSelected: boolean;
	endQuarter: string;
}

export interface OrderNumbers {
	key: string;
	isSelected: boolean;
}

export interface GlobalDocument {
	title: string;
	date: string;
	id: number;
	name: string;
	subtype: string;
	type: string;
	proforma?: string;
}

type DocumentType = 'IN' | 'DA' | 'CE' | 'OA' | 'XCARB';

export interface HeatNumbers {
	key: string;
	isSelected: boolean;
}

export interface DocumentExport {
	id?: number;
	path?: string;
	name?: string;
	fileNamePdf?: string;
	fileNameXml?: string;
	type?: DocumentType;
	subtype?: string;
	date?: string;
	transportMode?: string;
	transmitterSystem?: string;
	supplierVatNumber?: string;
	payerVatNumber?: string;
	customerClaimReference?: string;
	supplierClaimReference?: string;
	salesOrganization?: string;
	customerAnnouncementSegment?: string;
	proforma?: string;
	ceMarking?: number;
	counterSigned?: number;
	documentKey?: string;
	documentBase?: string;
	orderAcknowledgementDate?: string;
	dispatchAdviceDate?: string;
	paymentDueDate?: string;
	invoiceNumber?: string;
	payerName?: string;
	soldtoName?: string;
	shiptoName?: string;
	receiptDocumentDate?: string;
	documentCreationBy?: string;
	documentModificationDate?: string;
	documentModificationBy?: string;
	typeDescription?: string;
	subtypeDescription?: string;
	millDescription?: string;
	supplierMemberDescription?: string;
	transportModeDescription?: string;
	supplierOrderReference?: string;
	customerOrderReference?: string;
	rrpType?: string;
	rrpDocumentLink?: string;
	documentLines?: Partial<DocumentLine>[];
	millCode?: string;
	soldtoBusinessId?: string;
	shiptoBusinessId?: string;
	invoicedQuantity?: string;
	invoiceAmount?: number;
	invoiceAmountWithoutVat?: number;
	invoiceCurrency?: string;
	invoiceTaxAmount?: number;
	enduserBusinessId?: string;
	payerBusinessId?: string;
	supplierGroupId?: string;
	customerOrderItemReference?: string;
	supplierOrderReferenceItem?: string;
	millOrderReference?: string;
	millOrderReferenceItem?: string;
	customerArticleReference?: string;
	supplierArticleReference?: string;
	dispatchAdviceNumber?: string;
	batchNumber?: string;
	vendorBatchId?: string;
	heatNumber?: string;
	transportReference?: string;
	packageSerialNumber?: string;
	productDescription?: string;
	length?: number;
	invoicedQuatityUnit?: string;
	plantInvoiceNumber?: string;
	invoiceVatPercentage?: number;
	orderedQuantity?: number;
	steelGrade?: string;
	thickness?: number;
	width?: number;
	finalUse?: string;
	oaLineStatus?: string;
	rejectionReason?: string;
	displayOrderLines?: number;
	enduserName?: string;
	receiptDocumentLineDate?: string;
	documentLineCreationBy?: string;
	documentLineModificationDate?: string;
	documentLineModificationBy?: string;
	invoiceCurrencyDescription?: string;
	oaLineStatusDescription?: string;
	isSelected?: boolean;
	docNavigationLink?: string;
	isSbOrder?: boolean;
	endQuarter?: string;
	amount?: number;
}

export const DOCUMENTS_SUB_ENTITY = 'documentLines';

export type FieldOfDocument = keyof Document
	| `${ typeof DOCUMENTS_SUB_ENTITY }.${ keyof Document[typeof DOCUMENTS_SUB_ENTITY][number] }`;
